// extracted by mini-css-extract-plugin
export default {"list":"CheckboxGroup__list--2U2","groupControl":"CheckboxGroup__groupControl--2IJ","groupContent":"CheckboxGroup__groupContent--3jt"};